import React, { useState, useEffect } from 'react';
import api from '../api';

const Marquee: React.FC = () => {
  const [marqueeText, setMarqueeText] = useState<string>('');

  useEffect(() => {
    // Загружаем текст бегущей строки с сервера
    api.get('/public/marquee')
      .then((res) => {
        if (res.success && res.data?.text) {
          setMarqueeText(res.data.text);
        }
      })
      .catch((err) => {
        console.error('[Marquee] Failed to load:', err);
      });
  }, []);

  if (!marqueeText) {
    return null; // Не показываем пустую строку
  }

  return (
    <div
      style={{
        width: '100%',
        overflow: 'hidden',
        background: 'linear-gradient(90deg, rgba(13, 25, 48, 0.9) 0%, rgba(30, 58, 95, 0.7) 50%, rgba(13, 25, 48, 0.9) 100%)',
        borderTop: '1px solid rgba(212, 175, 55, 0.3)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
        padding: '14px 0',
        position: 'relative',
      }}
    >
      <div
        style={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          animation: 'marquee 60s linear infinite',
          color: '#e0e0e0',
          fontSize: '14px',
          fontFamily: 'var(--font-sans)',
          letterSpacing: '0.3px',
          lineHeight: 1.6,
        }}
      >
        {marqueeText}
        {'    ✦    '}
        {marqueeText}
      </div>

      <style>{`
        @keyframes marquee {
          0% {
            transform: translateX(100vw);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </div>
  );
};

export default Marquee;
